import './assets/css/App.css';
// Componentes
import Header from './components/Header';
import Router from './Router';

function App() {
  return (
    <div className="App">
      <section className="resolution-notice is-hidden-desktop is-hidden-tablet">
            <h1 className="resolution-notice-text-one">Sistema no apto para esta resolución</h1>
            <span className="resolution-notice-text-two">Por favor, accede desde una computadora de escritorio o tablet</span>
      </section>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" integrity="sha512-iBBXm8fW90+nuLcSKlbmrPcLa0OT92xO1BIsZ+ywDWZCvqsWgccV3gFoRBv0z+8dLJgyAHIhR35VZc2oM/gI1w==" crossOrigin="anonymous" />
      <Header></Header>
      <div className="content is-hidden-mobile">
        <Router></Router>
      </div>
    </div>
  );
}

export default App;
